'use client';

import React from 'react';
import { Phone, Mail, MapPin, Clock, Linkedin, Facebook, Instagram, MessageCircle } from 'lucide-react';
import { MotionDiv } from '@/components/motion';
import { trackWhatsAppClick } from '@/lib/tracking';

export default function ContactInfo() {
  return (
    <MotionDiv 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-white p-8 rounded-lg shadow-lg"
    >
      <h2 className="text-2xl font-bold mb-6">Información de Contacto</h2>
      
      <div className="space-y-6">
        <div className="flex items-start space-x-3">
          <Phone className="h-6 w-6 text-blue-600 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-medium">Teléfono</h3>
            <p className="text-gray-700">+54 011 4655-3067</p>
            <p className="text-gray-700">+54 011 4655-0225</p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <MessageCircle className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-medium">WhatsApp</h3>
            <div className="mt-2">
              <p className="text-sm font-medium text-gray-500 mb-1">Ventas</p>
              <p className="text-gray-700">
                <a
                  href="https://api.whatsapp.com/send?phone=541164202000"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={trackWhatsAppClick}
                  className="text-green-600 hover:text-green-800 hover:underline transition-colors"
                >
                  +54 9 11 6420-2000
                </a>
              </p>
              <p className="text-gray-700">
                <a
                  href="https://api.whatsapp.com/send?phone=541126772000"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={trackWhatsAppClick}
                  className="text-green-600 hover:text-green-800 hover:underline transition-colors"
                >
                  +54 9 11 2677-2000
                </a>
              </p>
            </div>
            <div className="mt-3">
              <p className="text-sm font-medium text-gray-500 mb-1">Administración</p>
              <p className="text-gray-700">
                <a
                  id="abrir_whatsapp"
                  href="https://api.whatsapp.com/send?phone=541161212156"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={trackWhatsAppClick}
                  className="text-green-600 hover:text-green-800 hover:underline transition-colors"
                >
                  +54 9 11 6121-2156
                </a>
              </p>
            </div>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <Mail className="h-6 w-6 text-blue-600 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-medium">Correo Electrónico</h3>
            <p className="text-gray-700">ventas@droquimar.com</p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <MapPin className="h-6 w-6 text-blue-600 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-medium">Dirección</h3>
            <p className="text-gray-700">Av. Crovara 2000/2014 (1766) </p>
            <p className="text-gray-700">La Tablada, Buenos Aires, Argentina </p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <Clock className="h-6 w-6 text-blue-600 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-medium">Horario de Atención</h3>
            <p className="text-gray-700">Lunes a Viernes: 8:30 - 13:00 y 14:00 - 17:30</p>
          </div>
        </div>
      </div>
      
      <div className="mt-8 pt-6 border-t border-gray-200">
        <h3 className="font-medium mb-4">Síguenos en redes sociales</h3>
        <div className="flex space-x-4">
          <a
            id="abrir_whatsapp_social"
            href="https://api.whatsapp.com/send?phone=541164202000"
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackWhatsAppClick}
            className="p-2 bg-green-100 rounded-full text-green-600 hover:bg-green-200 transition-colors duration-300"
            aria-label="WhatsApp"
          >
            <MessageCircle className="h-5 w-5" />
            <span className="sr-only">WhatsApp</span>
          </a>
          <a 
            href="https://www.facebook.com/droquimarsrl/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="p-2 bg-blue-100 rounded-full text-blue-600 hover:bg-blue-200 transition-colors duration-300"
            aria-label="Facebook"
          >
            <Facebook className="h-5 w-5" />
            <span className="sr-only">Facebook</span>
          </a>
          <a 
            href="https://www.instagram.com/droquimar/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="p-2 bg-pink-100 rounded-full text-pink-600 hover:bg-pink-200 transition-colors duration-300"
            aria-label="Instagram"
          >
            <Instagram className="h-5 w-5" />
            <span className="sr-only">Instagram</span>
          </a>
          <a 
            href="https://www.linkedin.com/company/16211455" 
            target="_blank" 
            rel="noopener noreferrer"
            className="p-2 bg-blue-100 rounded-full text-blue-700 hover:bg-blue-200 transition-colors duration-300"
            aria-label="LinkedIn"
          >
            <Linkedin className="h-5 w-5" />
            <span className="sr-only">LinkedIn</span>
          </a>
        </div>
      </div>
    </MotionDiv>
  );
} 